import type { StateCreator } from 'zustand';

import type { GeneratorTransferPayload, GeneratorTransferStore } from './types';

const TRANSFER_TTL_MS = 60_000;

function isExpired(payload: GeneratorTransferPayload): boolean {
  return Date.now() - payload.timestamp > TRANSFER_TTL_MS;
}

export const createGeneratorTransferSlice: StateCreator<
  GeneratorTransferStore
> = (set, get) => ({
  pending: null,

  setTransfer: (payload) => {
    set({ pending: { ...payload, timestamp: Date.now() } });
  },

  consumeTransfer: () => {
    const { pending } = get();
    if (!pending) {
      return null;
    }
    if (isExpired(pending)) {
      set({ pending: null });
      return null;
    }
    set({ pending: null });
    return pending;
  },

  clear: () => {
    set({ pending: null });
  },
});
